import { z } from 'zod';

/** Mirrors organization-service CreateOrganizationDto so errors surface before submit. */
export const SLUG_RE = /^[a-z][a-z0-9-]{1,38}[a-z0-9]$/;

export const onboardOrganizationSchema = z.object({
  legalName: z
    .string()
    .trim()
    .min(2, 'Enter the organization’s registered name (at least 2 characters)')
    .max(200, 'Use at most 200 characters'),
  slug: z
    .string()
    .min(1, 'An identifier is required')
    .regex(SLUG_RE, '3–40 characters: lowercase letters, numbers and hyphens, starting with a letter and not ending with a hyphen')
    .refine((v) => !v.includes('--'), 'Hyphens cannot be consecutive'),
  adminEmail: z
    .string()
    .trim()
    .min(1, 'An administrator email is required')
    .max(254, 'Use at most 254 characters')
    .email('Enter a valid email address'),
  countryCode: z.string().regex(/^[A-Z]{2}$/, 'Choose a country'),
});
export type OnboardOrganizationValues = z.infer<typeof onboardOrganizationSchema>;

/** Suggest an identifier from a legal name: "Acme (Pty) Ltd" -> "acme". */
export function suggestSlug(legalName: string): string {
  const base = legalName
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/\((pty|proprietary)\)|\b(pty|ltd|limited|inc|llc|cc|npc)\b\.?/g, ' ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-')
    .replace(/^[0-9-]+/, '')
    .slice(0, 40)
    .replace(/-+$/, '');
  return base;
}
